export default "__VITE_ASSET__DWKsYN3l__"